import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '@/modules/core/app/services/Lang';

export class ProtectionMandateFrequencyOfManagementOfPerson extends Enum {
  key!: number;
  value!: number;
  description!: string;

  static YEAR_1: ProtectionMandateFrequencyOfManagementOfPerson = {
    key: 1,
    value: 1,
    get description(): string {
      return Lang.t('protectionmandate.once-year');
    }
  };

  static YEAR_2: ProtectionMandateFrequencyOfManagementOfPerson = {
    key: 2,
    value: 2,
    get description(): string {
      return Lang.t('protectionmandate.once-every-years');
    }
  };

  static YEAR_3: ProtectionMandateFrequencyOfManagementOfPerson = {
    key: 3,
    value: 3,
    get description(): string {
      return Lang.t('protectionmandate.once-3-years');
    }
  };
}
